import React, { Component } from 'react'
import styled from 'styled-components'
import { vhToPx } from '@/utils'

export default class SponsorItem extends Component {
  render() {
    let {
      item,
      hasBorderBottom,
      backgroundColor,
      refClick,
      locked,
      playStackItem,
      playStackFromUnresolved,
      isAnnouncementAfterActive,
    } = this.props
    const PlayStackItemStyle = {
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'bottom -0.4vh right',
      backgroundSize: '1.4vh',
      backgroundImage: 'url(/static/media/preplay-up-arrow-black.86e9a30f.svg)',
    }
    return (
      <Container
        backgroundColor={backgroundColor}
        hasBorderBottom={hasBorderBottom}
        onClick={refClick}
        locked={locked}
        style={playStackItem ? PlayStackItemStyle : null}
      >
        <Wrapper
          style={{
            justifyContent: 'flex-end',
            paddingRight: playStackItem ? '2vh' : '0.5vh',
          }}
        >
          <ContentGroup style={{ paddingLeft: playStackItem ? '0' : '0.5vh' }}>
            <ItemName
              width={'auto'}
              pLeft={'0px'}
              pTop={'2px'}
              title={item.brandName || item.name}
              color={
                item &&
                (item.brandName || item.name || '')
                  .toLowerCase()
                  .includes('no brand')
                  ? '#fff'
                  : '#000'
              }
            >
              {item.brandName || item.name}
            </ItemName>
            {this.props.subBrandText && (
              <SubBrandText color={'#5c5a5a'} title={this.props.subBrandText}>
                {this.props.subBrandText}
              </SubBrandText>
            )}
          </ContentGroup>
          {!this.props.hideIcon && (
            <Thumbnail
              style={{ width: 'auto', marginLeft: '1.5vh', flexShrink: 0 }}
              isAnnouncementAfterActive={isAnnouncementAfterActive}
            >
              <Circle
                src={item.brandImage}
                style={{
                  width: '3vh',
                  height: '3vh',
                  paddingBottom: 0,
                  minWidth: '3vh',
                  minHeight: '3vh',
                }}
              />
            </Thumbnail>
          )}
        </Wrapper>
      </Container>
    )
  }
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  background-color: ${props => props.backgroundColor};
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  ${props =>
    props.hasBorderBottom ? `border-bottom: ${0.1}vh solid #d9d9d9` : ''};
`

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`

const ContentGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  min-width: 0;
`

const ItemName = styled.div`
  width: 100%;
  padding-left: ${props => props.pLeft || '1vh'};
  padding-top: ${props => props.pTop || ''};
  font-family: pamainregular;
  font-size: ${props => props.fontSize || 100 * 0.02}vh;
  text-transform: uppercase;
  display: block;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${props => props.color || '#000'};
`

const SubBrandText = styled.div`
  width: 100%;
  display: block;
  text-align: right;
  font-family: pamainregular;
  font-size: 1.35vh;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${props => props.color || '#000'};
  margin-top: 0.2vh;
`

const Thumbnail = styled.div`
  width: ${props => (props.isAnnouncementAfterActive ? '10%' : '22%')};
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1%;
`

const Circle = styled.div`
  position: relative;
  width: 90%;
  min-width: 90%;
  height: 0;
  padding-bottom: 90%;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  &:before {
    content: '';
    position: absolute;
    width: 90%;
    height: 90%;
    min-width: 90%;
    min-height: 90%;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  &:after {
    width: 90%;
    height: 90%;
    border-radius: 50%;
    position: absolute;
    content: '';
    display: inline-block;
    background-image: url(${props => props.src});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`

const ExposureCount = styled.div`
  width: 18%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const ExposureCountText = styled.span`
  font-family: pamainbold;
  font-size: ${props => 100 * 0.02}vh;
  color: #000000;
  line-height: 1;
`



// WEBPACK FOOTER //
// src/Components/CommandHost/Common/SponsorItem.js